import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import cn from 'classnames';
import get from 'lodash/get';
import size from 'lodash/size';
import React, {PureComponent} from 'react';
import css from './css.css';

import StyledCol from "~/components/TargetGrid/StyledCol";
import { Heading, Grid, Row, Col } from '~/native-ui';

import { ROW_GAP, rowProps } from './utils';
import { useBreakpointValue } from 'native-base';

class TargetRowClass extends PureComponent {
    static propTypes = {
        elements: PropTypes.arrayOf(PropTypes.shape({
            element: PropTypes.node.isRequired,
        })),
        xs: PropTypes.number.isRequired,
        md: PropTypes.number,
        lg: PropTypes.number,
        sm: PropTypes.number,
        xl: PropTypes.number,
        colStyles: PropTypes.object,

        captions: PropTypes.object,

        elementColClassName: PropTypes.string,
        rowClassName: PropTypes.string,
        captionRowClassName: PropTypes.string
    };

    static defaultProps = {
        xs: 3,
        captions: null,
        elements: [],
        keyPrefix: '',
    };

    computeColSizes = () => {
        return {
            xs: this.props.xs,
            md: this.props.md,
            lg: this.props.lg,
            xl: this.props.xl,
            sm: this.props.sm,
        };
    };

    renderEmptyColumn = ({ colSizes, maxCols, index }) => {
        return (
            <StyledCol
                {...colSizes}
                {...this.props.columnStyle}
                colCount={maxCols}
                gap={ROW_GAP}
                key={"empty-cell" + index}
                className={this.props.elementColClassName}
            >
            </StyledCol>
        )
    }

    renderRows = () => {
        let colSizes = this.computeColSizes();
        let maxCols = this.props.maxCols;
        // let maxCols = [this.props.xs, this.props.md, this.props.lg, this.props.sm]
        //         .reduce((max, current) => current > max ? current : max, 0);

        let level = get(this.props.columnStyle, 'level');

        // console.log('colSizes', colSizes)

        let groupCaptionsRendered = {};

        let getCols = (elements) => {
            let captionCols = [];
            let elementCols  = [];

            for(let i = 0; i < maxCols; i++) {
                if(i >= (elements.length)) {
                    continue;
                }

                let elementData = elements[i];

                if(this.props.captions) {
                    if(groupCaptionsRendered[elementData.group]) {
                        captionCols.push(<Col {...colSizes} colCount={maxCols} gap={ROW_GAP} key={`col-spacer-${i}-${elementData.name}`} />);
                    } else {
                        captionCols.push(<Col {...colSizes} colCount={maxCols} gap={ROW_GAP} key={`col-caption-${i}-${elementData.name}`} >
                            <Heading size="sm">{this.props.captions[elementData.group]}</Heading>
                        </Col>);

                        groupCaptionsRendered[elementData.group] = true;
                    }
                }

                elementCols.push(
                    <StyledCol
                        {...colSizes}
                        {...this.props.columnStyle}
                        key={i}
                        className={this.props.elementColClassName}
                        colCount={maxCols}
                        gap={ROW_GAP} 
                    >
                        {elementData.element}
                    </StyledCol>
                );
            }

            return { captionCols, fieldCols: elementCols };
        };

        let allRows = chunk(this.props.elements, maxCols),
            rows = [];

        for(let i = 0; i < allRows.length; i++) {
            let { captionCols, fieldCols } = getCols(allRows[i]),
                blankCells = new Array(maxCols - fieldCols.length).fill(null).map((x, index) => this.renderEmptyColumn({ colSizes, maxCols, index }));

            if(size(this.props.captions)) {
                rows.push((<Row key={`${this.props.keyPrefix}-row-caption-${i}`} className={cn(this.props.captionRowClassName)}>
                    {captionCols}
                    {blankCells}
                </Row>))
            }


            // TODO: Revisit rowProps;
            const extraProps = this.props.rowProps ?? rowProps

            rows.push(
                <Row key={`${this.props.keyPrefix}-row-${i}`} {...extraProps} className={cn(this.props.rowClassName)}>
                    {fieldCols}
                    {blankCells}
                </Row>
            )
        }

        return rows;
    };

    render() {
        return (
            <Row level={this.props.level}>
                <Grid className={cn(this.props.className, css.targetGrid)}>
                    {this.renderRows(this.props)}
                </Grid>
            </Row>
        );
    }
}

const TargetRow = React.memo((props) => {
    const { md, xs = 3, lg, sm, gridWidth = 12 } = props;
    const columnSpan = useBreakpointValue({
        base: xs,
        lg: lg,
        md: md,
        sm: sm,
    });

    if(gridWidth % columnSpan) {
        throw new Error('invalid this.props.fieldsPerRow '+ columnSpan);
    }

    return <TargetRowClass {...props} gridWidth={gridWidth} maxCols={gridWidth / columnSpan} />
})

export default TargetRow;